<template>
    <div class="text-center">
        <h2>{{ $route.params.msg }}</h2>
        <router-link to="/" class="text-h5">Retour à l'accueil</router-link>
    </div>
</template>
